import TutorialListPage from './list'
export default TutorialListPage
